import React, { useEffect, useState } from "react"
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    DialogActions,
    Box,
    Button,
    Divider,
    Alert
} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import { FormProvider, useForm } from "react-hook-form"

import styles from 'components/modal/modal.module.css';
import ClearIcon from '@mui/icons-material/Clear';

import Loader from 'components/Loader';


const DialogAlert = (Props) => {
    const { open, setOpen, handleSubmit, title, message, type, loading, data } = Props
    const methods = useForm()

    useEffect(() => {
        methods.reset()
    }, [open])

    const Submit = () => {
        handleSubmit?.(methods.getValues())
        setOpen(false)
    }

    return (
        <FormProvider {...methods}>

            <Loader loading={loading} />
            <Dialog open={open} onClose={() => setOpen(false)} >

                <Box className={styles.backgroundModal}>
                    <Box className={styles.boxModal}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Box sx={{ display: 'flex', gridGap: '10px' }}>
                                <Box sx={{ border: `5px solid ${type === 'error' ? '#B22222' : '#478F96'}` }} />
                                <Box sx={{
                                    fontWeight: 600,
                                    fontSize: '18px',
                                    color: '#478F96',
                                    "@media (max-width: 800px)": {
                                        fontSize: '16px',
                                    }
                                }}>  {title}</Box>
                            </Box>
                            <Box sx={{ '&:hover': { cursor: 'pointer' } }} onClick={() => setOpen(false)}>
                                <IconButton>
                                    <ClearIcon />
                                </IconButton>
                            </Box>
                        </Box>

                        <Box sx={{ display: 'grid', gridGap: '20px' }}>
                            <Box>
                                <Alert severity={type}>{message}</Alert>
                            </Box>
                            <Box>
                                {data?.error_list && data?.error_list.map((d, index) => (
                                    <Alert key={index} severity={'error'}>
                                      {index+1}.  {d.message}
                                    </Alert>
                                ))}
                            </Box>
                            <Button variant='contained' onClick={() => setOpen(false)}>
                                ปิด
                            </Button>
                        </Box>
                    </Box>
                </Box>
                <DialogTitle
                    sx={{
                        boxShadow: "0px 0px 10px 1px #D4D4D4",
                        padding: "5px 20px",
                        textAlign: "center",
                        backgroundColor: "#3671B7",
                        color: "white",
                    }}
                >
                    {title}
                </DialogTitle>



            </Dialog>
        </FormProvider>
    )
}

export default DialogAlert
